import "./infoEvento.css";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader

import { Col, Row, Spinner } from "react-bootstrap";
import React, { useEffect, useState } from "react";

import { Carousel } from "react-responsive-carousel";
import GoogleMaps from "simple-react-google-maps";
import ReactPlayer from "react-player";
import { useTranslation } from "react-i18next";

function InfoEvento({ evento }) {
  if (evento.ubication.gps.longitude !== "") {
    var longitud = parseFloat(evento.ubication.gps.longitude);
    var latitud = parseFloat(evento.ubication.gps.latitude);
  } else {
    longitud = 0;
    latitud = 0;
  }

  const [t, i18n] = useTranslation("global");
  const [categoria, setCategoria] = useState();
  const [email, setEmail] = useState();
  const [telefono, setTelefono] = useState();
  const [entidad, setEntidad] = useState();
  const [loading, setLoading] = useState(true);
  const [publico, setPublico] = useState();

  if (evento.description !== "") {
    var arrayDeCadenas = evento.description.split("#");
    var descripcionEus = arrayDeCadenas[0].split("\n\n");
    var descripcionEs = arrayDeCadenas[1].split("\n\n");
  } else {
    arrayDeCadenas = [];
    descripcionEus = [];
    descripcionEs = [];
  }
  /*  console.log(evento.category); */
  useEffect(() => {
    if (evento.category[0] !== "") {
      if (evento.category[0] === "feria") {
        setCategoria(t("header.titeres-actores"));
      } else if (evento.category[0] === "circo") {
        setCategoria(t("header.teatro-instalaciOn-artistica"));
      } else if (evento.category[0] === "concert") {
        setCategoria(t("header.teatro-actores"));
      } else if (evento.category[0] === "ballet") {
        setCategoria(t("header.teatro-sensorial-primera-infancia"));
      } else if (evento.category[0] === "ópera") {
        setCategoria(t("header.teatro-clown"));
      } else if (evento.category[0] === "deporte") {
        setCategoria(t("header.teatro-titeres-objetos-danza"));
      } else if (evento.category[0] === "festival") {
        setCategoria(t("header.teatro-objetos-primera-infancia"));
      } else {
        setCategoria(evento.category[0]);
      }
    } else {
      setCategoria("");
      setCategoria("");
    }
    if (evento.tags[0] != "") {
      if (evento.tags[0] === "familiar, a partir de 4 años") {
        setPublico(t("header.publico-4años"));
      } else if (evento.tags[0] === "familiar, a partir de 5 años") {
        setPublico(t("header.publico-5años"));
      } else if (evento.tags[0] === "familiar, con menores de 2 a 4 años") {
        setPublico(t("header.publico-menores"));
      }
    }
    if (loading) {
      setLoading(false);
    }
  }, [evento, loading]);

  console.log(evento.ubication.location);
  return (
    <div>
      {loading ? (
        <Spinner animation="border" />
      ) : (
        <Row>
          <Col style={{ marginBottom: "50px" }}>
            <div className="descripcin montserrat-medium-thunder-25px">
              {t("header.descripcion")}
            </div>
            <div className="la-cantante-y-compos">
              {i18n.language === "es" ? (
                <div style={{ justifyContent: "center", marginTop: "45px" }}>
                  {descripcionEs.map((data, key) => {
                    return (
                      <div key={key} style={{ marginTop: "-40px" }}>
                        <Row style={{ lineHeight: "30px" }}>{data}</Row>
                        <br></br>
                      </div>
                    );
                  })}
                  {evento._id === "62defc87a35bc5db07fab361" || evento._id === "62dfc1c8a35bc5db07fabe69" ?
                    (
                      <>
                        <Row style={{ lineHeight: "30px", fontWeight: "bold", color: "black", marginBottom: "50px" }}>*Todas las personas asistentes deberán comprar entrada. Se recomienda un máximo de dos acompañantes adultos por menor.</Row>
                      </>
                    ) : (
                      <></>
                    )}
                </div>
              ) : (
                <div>
                  {descripcionEus.map((data, key) => {
                    return (
                      <div key={key} style={{ marginTop: "-40px" }}>
                        <Row style={{ lineHeight: "30px" }}>{data}</Row>
                        <br></br>
                      </div>
                    );
                  })}
                  {evento._id === "62defc87a35bc5db07fab361" || evento._id === "62dfc1c8a35bc5db07fabe69" ?
                    (
                      <>
                        <Row style={{ lineHeight: "30px", fontWeight: "bold", color: "black", marginBottom: "50px" }}>*Bertaratutako guztiek erosi beharko dute sarrera. Gehienez, umetxo bakoitzeko gehienez bi heldu etortzea gomendatzen da.</Row>
                      </>
                    ) : (
                      <></>
                    )}
                </div>
              )}
            </div>
            {evento.galery.length > 0 ? (
              <>
                <div style={{ marginTop: "50px" }}>
                  <Carousel showArrows={true}>
                    {evento.galery.map((data, key) => {
                      return (
                        <div key={key}>
                          <img src={data} alt="" />
                        </div>
                      );
                    })}
                  </Carousel>
                </div>
                {evento.url.includes("youtube") ||
                  evento.url.includes("vimeo") ? (
                  <div>
                    <div className="descripcin" style={{ marginTop: "-6px" }}>
                      {" "}
                      {t("header.video")}
                    </div>

                    <ReactPlayer
                      style={{ marginTop: "20px" }}
                      url={evento.url}
                      className="react-player"
                      playing={false}
                      height="360px"
                      width="auto"
                      controls
                    />
                  </div>
                ) : (
                  <div></div>
                )}
              </>
            ) : (
              <>
                {evento.url.includes("youtube") ||
                  evento.url.includes("vimeo") ? (
                  <div>
                    <div className="descripcin" style={{ marginTop: "-6px" }}>
                      {" "}
                      {t("header.video")}
                    </div>

                    <ReactPlayer
                      style={{ marginTop: "20px" }}
                      url={evento.url}
                      className="react-player"
                      playing={false}
                      height="360px"
                      width="auto"
                      controls
                    />
                  </div>
                ) : (
                  <div></div>
                )}
              </>
            )}
          </Col>
          <Col style={{ marginBottom: "50px" }}>
            <div className="overlap-group1">
              <Row>
                <Col style={{ marginLeft: "20px" }}>
                  <div className="ciclo-1 montserrat-medium-thunder-25px">
                    {t("header.genero")}
                  </div>
                  <h1 className="title">{categoria}</h1>
                </Col>

                <Col>
                  <div className="ciclo-1 montserrat-medium-thunder-25px">
                    {t("header.idioma")}
                  </div>
                  <h1 className="title">
                    {evento.language_event === "Castellano"
                      ? t("header.castellano")
                      : ""}
                    {evento.language_event === "Euskera" ? t("header.euskera") : ""}
                    {evento.language_event === "Otros" ? t("header.otros") : ""}
                    {evento.language_event === "Bilingue" ? t("header.bilingue") : ""}
                    {evento.language_event === "Frances" ? t("header.frances") : ""}
                    {evento.language_event === "Ingles" ? t("header.ingles") : ""}
                    {evento.language_event === "Obra Muda"
                      ? t("header.obra-muda")
                      : ""}
                  </h1>
                </Col>
                {/* width 150pc */}
                <Col sm={6}>
                  <div className="ciclo-1 montserrat-medium-thunder-25px">
                    {t("header.publico")}
                  </div>
                  <h1 className="title" style={{ fontSize: "17px" }}>{publico} </h1>
                </Col>
                <Col>
                  <div className="ciclo-1 montserrat-medium-thunder-25px">
                    {t("header.duraccion")}
                  </div>
                  <h1 className="title">{evento.tags[3]}</h1>
                </Col>
                {evento.tags.length > 2 ? (
                  <Col>
                    <div className="ciclo-1 montserrat-medium-thunder-25px">
                      {t("header.compania")}
                    </div>
                    <h1 className="title">{evento.tags[1]}</h1>
                  </Col>

                ) : (
                  <div></div>
                )}
              </Row>
            </div>

            <div className="ubicacionEven">
              <div style={{ width: "100%" }}>
                <div className="ubicacinEven montserrat-medium-thunder-25px">
                  {t("header.ubicacion")}
                </div>
                <div>
                  <GoogleMaps
                    apiKey={"AIzaSyCEpRrgB2-1d7Ph48KbvZmK6o7nImqSm4Q"}
                    style={{
                      height: "300px",
                      width: "auto",
                      top: "20px",
                    }}
                    zoom={15}
                    center={{
                      lat: latitud,
                      lng: longitud,
                    }}
                    markers={[{ lat: latitud, lng: longitud }]}
                  />
                </div>
                {evento.ubication.location === undefined ? (
                  <h6 className="text-3Even">{evento.location}</h6>
                ) : (
                  <>
                    {evento.ubication.location === "Centro Cívico Clara Campoamor" ?
                      (
                        <h6 className="text-3Even">{t("header.dirrecion")}</h6>
                      ) : (
                        <>
                          {evento.ubication.location === "Centro Cívico de Cruces" ?
                            (
                              <h6 className="text-3Even">{t("header.dirrecion-2")}</h6>
                            ) : (
                              <h6 className="text-3Even">{evento.ubication.location}</h6>
                            )
                          }
                        </>
                      )}
                  </>
                )}

                {evento.ubication.location === "Centro Cívico Clara Campoamor" ?
                  (
                    <p className="text-DirEven">
                      {t("header.dirreccionCamponar")}
                    </p>
                  ) : (
                    <>
                      {evento.ubication.location === "Centro Cívico de Cruces" ?
                        (
                          <p className="text-DirEven">
                            {t("header.direccionCruce")}
                          </p>
                        ) : (
                          <h6 className="text-3Even">{evento.ubication.location}</h6>
                        )
                      }
                    </>
                  )}

                {/* <p className="text-DirEven">
                {evento.ubication.city}
                {", "}
                {evento.ubication.province}
              </p> */}
              </div>
            </div>

            {/* datos organizador */}
            {/* <div style={{ marginTop: "40px" }} className="overlap-group1">
              <Row>
                <Col>
                  <div className="ciclo-1 montserrat-medium-thunder-25px">
                    {t("header.Datos_organizador")}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="ciclo-1 montserrat-medium-thunder-25px">
                    {t("header.email")}
                  </div>
                  <h1 className="title">{email}</h1>
                </Col>
                <Col style={{ marginLeft: "20px" }}>
                  <div className="ciclo-1 montserrat-medium-thunder-25px">
                    {t("header.telefono")}
                  </div>
                  <h1 className="title">{telefono}</h1>
                </Col>
                <Col style={{ marginLeft: "20px" }}>
                  <div className="ciclo-1 montserrat-medium-thunder-25px">
                    {t("header.entidad")}
                  </div>
                  <h1 className="title">{entidad}</h1>
                </Col>
              </Row>
            </div> */}
          </Col>
        </Row>
      )}
    </div>
  );
}

export default InfoEvento;
